import { render } from "./EditarServico.vue?vue&type=template&id=1c1240ff"
import script from "./EditarServico.vue?vue&type=script&lang=js"
export * from "./EditarServico.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__